import { Outlet, createFileRoute } from '@tanstack/react-router';

import fx from '#/fx';
import { Footer } from './-components/footer';
import { Navbar } from './-components/navbar';

export const Route = createFileRoute('/_main')({
  loader: async () => {
    const global = await fx.getGlobalConfig();
    return {
      global,
    };
  },
  component: MainLayout,
});

function MainLayout() {
  const { global } = Route.useLoaderData();
  return (
    <div className='quark-layout-main'>
      <Navbar {...global.layout.navbar} />
      <div className='pt-[64px]'>
        <Outlet />
      </div>
      <Footer {...global.layout.footer} />
    </div>
  );
}
